export const CSentrySeverityLevels = {
    FATAL: 'fatal',
    ERROR: 'error',
    WARNING: 'warning',
    LOG: 'log',
    INFO: 'info',
    DEBUG: 'debug'
} as const;

export type SeverityLevelType = typeof CSentrySeverityLevels[keyof typeof CSentrySeverityLevels]